let suppressedUntil = 0;

export const suppressToasterErrors = (ms = 3000) => {
    suppressedUntil = Math.max(suppressedUntil, Date.now() + ms);
};

export const areToasterErrorsSuppressed = () => Date.now() < suppressedUntil;